import React, {useEffect} from "react";
import {Link} from "react-router-dom";

function GolfRules() {

    useEffect(() => {
        document.title = "Pick 5 Golf Rules";
    }, []);

    return (
        <div>
            <h4>Pick 5 Golf Contest Rules</h4>
            <div>
                <p>Rules:
                    <ol>
                        <li>The overall prize goes to the entry with the lowest cumulative score.</li>
                        <li>If multiple entries tie for the overall prize they will split the prize.</li>
                        <li>
                            Payouts: $50 * 34 = $1700 total. 43 events (6 majors count as double) * (9 + 7 + 5 + 4 + 3 + 2) =
                            1421 weekly prizes. $43 in aces pot + $43 winners pot + $143 for overall prizes: $34 + 30 + 26 + 22 + 18 + 14.
                            <br/>
                            Majors are:
                            <ol>
                                <li>Masters Tournament</li>
                                <li>The Players Championship</li>
                                <li>U.S. Open</li>
                                <li>The Open Championship</li>
                                <li>PGA Championship</li>
                                <li>Tour Championship</li>
                            </ol>
                        </li>
                        <li>If multiple entries tie in a tournament, the tie breaker will be which entry had the lowest
                            score in
                            the final round. If they tie in that round, the earlier rounds will be compared (3, 2, 1).
                            If they
                            are still tied, the weekly prize will be split.
                        </li>
                    </ol>

                </p>
            </div>
            <Link className="ContestLink" to="/golf" key='link-mainpage'>Return to the main page</Link>
        </div>
    );
}

export default GolfRules;
